import { Controller } from "@hotwired/stimulus"

// Espelha o seletor de cor nativo no campo de texto hexadecimal (e vice-versa)
// nos campos de cor da Gestao do site.
export default class extends Controller {
  static targets = ["texto", "seletor"]

  connect() {
    this.doTexto()
  }

  doTexto() {
    const valor = this.textoTarget.value.trim()
    if (/^#[0-9a-fA-F]{6}$/.test(valor)) this.seletorTarget.value = valor
  }

  doSeletor() {
    this.textoTarget.value = this.seletorTarget.value.toUpperCase()
  }
}
